import { cn } from '@lfg/ui/lib';
import React, { HTMLAttributes, ReactNode } from 'react';
import { useId } from 'react';

interface NodeCardProps {
  children: ReactNode;
  className?: string;
  hoverEffect?: 'shadow' | 'bgcolor';
  onClick?: HTMLAttributes<HTMLDivElement>['onClick'];
}

export const NodeCard: React.FC<NodeCardProps> = ({
  children,
  className = '',
  hoverEffect = 'bgcolor',
  onClick = () => {},
}) => {
  const maskId = useId();
  const gradient1Id = useId();
  const gradient2Id = useId();

  return (
    <div
      className={cn(
        'relative overflow-hidden transition-all duration-300 cursor-pointer border border-white-alpha-10',
        hoverEffect === 'shadow' && 'hover:shadow-lg hover:shadow-purple-500/20',
        hoverEffect === 'bgcolor' && 'group',
        className,
      )}
      onClick={onClick}>
      {/* SVG background */}

      {/* Hover background color overlay (only visible when hoverEffect is 'bgcolor') */}
      {hoverEffect === 'bgcolor' && (
        <div className='absolute inset-0 bg-brand-hover-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-0'></div>
      )}

      {/* Content container */}
      <div className='relative overflow-hidden z-10 w-full h-full flex flex-col border border-white-alpha-10'>
        {children}
      </div>
    </div>
  );
};
